import { Link, useNavigate } from 'react-router-dom';
import p_nav_previous from '../Assets/Images/p_navbars.svg';
import { deleteMyAccount, getMyProfileDetails, notificationCounts } from '../Services/api';
import { useRef, useState } from 'react';
import p_nav_book_outline from "../Assets/Images/p_nav_book_outline.svg";
import p_nav_message_outline from "../Assets/Images/p_nav_message_outline.svg";
import p_nav_notifications_outline from "../Assets/Images/p_nav_notifications_outline.svg";
import p_nav_about_outline from "../Assets/Images/p_nav_about_outline.svg";
import p_nav_setting_outline from "../Assets/Images/p_nav_setting_outline.svg";
import p_nav_location from "../Assets/Images/p_nav_location.png";
import user_icon from "../Assets/Images/Pingle-User-Logo.png";

import p_nav_next_outline from "../Assets/Images/p_nav_next_outline.svg";
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import GuestUserSideBar from '../Components/SideBar/guestUser_sideBar';
import { IoMdClose } from "react-icons/io";
import Lottie from "lottie-react";
import thankyou from "../Assets/lottieFiles/newThankyou.json"
import NodeaxiosInstance from '../Services/nodeaxios';

const AboutPingle = () => {

  const navigate = useNavigate();
  function deleteAccount() {
    deleteMyAccount().then((res) => {
      localStorage.removeItem("user");
      sessionStorage.clear();
      localStorage.clear();
      navigate('/login', { state: { fromGuest: true } })
    });
  }
  const state = useSelector((state) => state);
  const [userData, serUserData] = useState(state?.userAuth?.user);
  const [modalOpen, setModalOpen] = useState(false);

  const [showSidebar, setShowSidebar] = useState(false);
  const [showLottie, setShowLottie] = useState(false)
  const [feedBack, setFeedBack] = useState("");
  const [feedBackmodalOpen, setFeedBackModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const timeoutRef = useRef(null);


  const toggleSidebar = () => {
    setShowSidebar(!showSidebar)
  }
  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  function removeExtraFadeFromOffcanvas() {
    const myOffcanvas = document.getElementById('offcanvasTop');
    myOffcanvas.addEventListener('shown.bs.offcanvas', event => {
      let fade = document.getElementsByClassName('offcanvas-backdrop fade show')
      for (let i = 0; i < fade.length; i++) {
        while (fade.length > 1) {
          fade[i].remove()
        }
      }
    });
  }

  const [notificationcount, setNotificationcount] = useState("");
  const [profile, setProfileData] = useState("");

  useEffect(() => {
    getMyProfileDetails().then((res) => {
      setProfileData(res.data?.user_details);
    });
    notificationCounts().then((res) => {

      setNotificationcount(res.data);
    });
  }, [])

  const handleClose = () => {
    setFeedBackModalOpen(false);
    setFeedBack("");
    setIsSuccess(false);
    setIsSubmitting(false);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };


  const submitFeedBack = async () => {
    if (!feedBack.trim()) return;

    try {
      setIsSubmitting(true);

      await NodeaxiosInstance.post(
        "/profile/send-founder-feedback",
        { feedback: feedBack.trim() }
      );

      setIsSuccess(true);

      timeoutRef.current = setTimeout(() => {
        handleClose();
      }, 3000);

    } catch (error) {
      console.error("Feedback API error:", error);
      console.log("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white  offcanvas-parentType1">
        <div className="d-flex justify-content-between align-items-center  ">
          {
            userData?.user_type == "Guest" ?
              <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' onClick={() => toggleSidebar()} /> :

              <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasTop" aria-controls="offcanvasTop" onClick={removeExtraFadeFromOffcanvas} />
          }
          {/* <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasTop" aria-controls="offcanvasTop" onClick={removeExtraFadeFromOffcanvas} /> */}
          <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1'>About</div>
        </div>

        <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel" >
          <div className="offcanvas-body p-0">
            <Link to={`/dashboard`} className="text-decoration-none">
              <div className="profileDetails primary-bg p-3 text-white d-flex justify-content-between align-items-center">
                <div className="d-flex">
                  <img src={profile?.user_img} width={"84px"} height={"81px"} className='profile' />
                  <div className="ms-2">
                    <div className="ff-poppins-semiBold fs-16">
                      {profile?.user_name}
                    </div>
                    <div className="ff-balooPaaji2-regular fs-12">
                      UID:{profile?.user_id}
                    </div>
                    {profile?.user_city &&
                      <div className="ff-balooPaaji2-regular fs-12">
                        <img src={p_nav_location} width={"12px"} height={"12px"} className="me-1" />
                        {profile?.user_city}
                      </div>
                    }

                  </div>
                </div>
                <img src={p_nav_next_outline} width={"24px"} height={"24px"} />
              </div>
            </Link>

            <div>
              <div className="d-flex p-3" role="button" onClick={() => navigate('/')} >

                <img src={p_nav_book_outline} width={"24px"} height={"24px"} />
                <div className="ff-poppins-regular fs-16 ms-3">
                  Bookings Manager
                </div>
              </div>

              <Link
                to={`/messenger-list`}
                className="text-decoration-none text-dark"
              >
                <div className="d-flex p-3" role="button">
                  <img src={p_nav_message_outline} width={"24px"} height={"24px"} />
                  <div className="d-flex justify-content-between w-100">
                    <div className="ff-poppins-regular fs-16 ms-3">Messenger</div>
                    <p className="">
                      {notificationcount.unread_message_count > 0 ?
                        <span className="notification_count">
                          {notificationcount.unread_message_count >= 9 ? "9+" : notificationcount.unread_message_count}
                        </span> : <></>
                      }
                    </p>
                  </div>
                </div>
              </Link>

              <div className="d-flex sidebar p-3 " role="button" onClick={() => navigate("/notifications", { state: { UserId: profile.user_id } })}>
                <img src={p_nav_notifications_outline} width={"24px"} height={"24px"}
                />
                <div className="d-flex justify-content-between w-100">
                  <div className="ff-poppins-regular fs-16 ms-3">
                    Notification
                  </div>
                  <p className="p-0 m-0">
                    {notificationcount.unread_count > 0 ?
                      <span className="notification_count">
                        {notificationcount.unread_count >= 9 ? "9+" : notificationcount.unread_count}
                      </span> : <></>
                    }
                  </p>
                </div>
              </div>

              <Link to={`/aboutPingle`} className="text-decoration-none text-dark" >
                <div className="d-flex p-3" role="button">
                  <img src={p_nav_about_outline} width={"24px"} height={"24px"} />
                  <div className="ff-poppins-regular fs-16 ms-3">
                    About Pingle
                  </div>
                </div>
              </Link>

              <Link to={`/settings`} className="text-decoration-none text-dark">
                <div className="d-flex p-3" role="button">
                  <img
                    src={p_nav_setting_outline}
                    width={"24px"}
                    height={"24px"}
                  />
                  <div className="ff-poppins-regular fs-16 ms-3">Settings</div>
                </div>
              </Link>
            </div>
          </div>
        </div>

        {showSidebar &&
          <GuestUserSideBar isOpen={showSidebar} user={userData} onClose={() => setShowSidebar(false)} />
        }
      </div>

      <div className='scroller-style-y m-3 p-1 d-flex flex-column justify-content-between'>
        <div className='ff-poppins-regular fs-16'>
          Pingle is your go-to hyperlocal booking app, effortlessly connecting you to businesses in your area.
          With a gamified experience that makes booking fun, you can search for services/products, book and reschedule appointments, get offers and discounts, make payments, and earn loyalty points—all in one place. Enjoy the ultimate convenience with Pingle, bringing everything you need right to your fingertips.
          Effortless, seamless, and all from the comfort of your home—Pingle puts control back in your hands
        </div>

        <div className=''>
          <a href='https://pingle.in/user/privacy_policy.php' target='_blank' className='text-decoration-none text-dark'>
            <div className='ff-poppins-regular fs-16 text-center linkBtn' role='button'>
              Privacy Policy
            </div>
          </a>
          <a href='https://pingle.in/user/terms-conditons.php' target='_blank' className='text-decoration-none text-dark'>
            <div className='ff-poppins-regular fs-16 text-center linkBtn' role='button'>
              Terms and Conditions
            </div>
          </a>
          {/* <div className='ff-poppins-regular fs-16 text-center linkBtn' role='button' data-bs-toggle="modal" data-bs-target="#exampleModal">
						  Delete account
						  </div> */}
          {userData?.user_type == "User" &&
            <div className="ff-poppins-regular fs-16 text-center linkBtn" role="button" onClick={openModal}>
              Delete Pingle account
            </div>} 
            <div className="ff-poppins-regular fs-16 text-center linkBtn" role="button" onClick={() => setFeedBackModalOpen(true)}>
              Feedback to Founder
            </div> 
          <div className='ff-poppins-regular fs-10 text-center mb-3'>
            App Version 1.4.8
          </div>
        </div>
      </div>


      {/* Modal */}
      {modalOpen && (
        <div className="modal fade show successModal" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-modal="true">
          <div className="modal-dialog modal-dialog-centered modal-sm m-0" style={{ maxWidth: "330px" }}>
            <div className="modal-content rounded-4">
              <div className="modal-body p-3 ">
                <div>
                  <img src={user_icon} width="45" height="45" className="mb-2" />
                  <h5 className="ff-poppins-semiBold fs-16 mb-1">
                    Delete Pingle account across apps?
                  </h5>

                  <p className="ff-poppins-regular fs-12 mb-0">
                    Once deleted, you will lose access to this account along with the saved details on Pingle.
                  </p>
                </div>

                <div className="d-flex justify-content-between mt-3">
                  <div className="small-btn primary-text primary-bg-light"
                    onClick={closeModal} >
                    Cancel
                  </div>
                  <div className="small-btn text-light primary-bg"
                    onClick={deleteAccount} >
                    Proceed
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {feedBackmodalOpen && (
        <> 
          <div className="modal-backdrop fade show" onClick={handleClose}    ></div>

          <div className="offcanvas offcanvas-bottom-modal show">
            {!isSuccess ? (
              <>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span className="fs-14 ff-poppins-semiBold">
                    Feedback to Founder
                  </span>

                  <span
                    className="fs-20 cursor-pointer"
                    onClick={handleClose}
                  >
                    <IoMdClose />
                  </span>
                </div>

                <textarea
                  className="founderfeedBacktextArea ff-poppins-regular fs-13 mb-1 text-dark"
                  placeholder="Type your feedback here..."
                  value={feedBack}
                  maxLength={250}
                  onChange={(e) => setFeedBack(e.target.value)}
                />

                <div className="d-flex justify-content-end fs-12 mt-1">
                  {feedBack.length} / 250
                </div>

                <button
                  className="primary-bottom-btn rounded-3 mt-2 fs-14 ff-poppins-medium text-center w-100"
                  disabled={isSubmitting || !feedBack.trim()}
                  onClick={submitFeedBack}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </>
            ) : (
              <div className="text-center">
                <Lottie animationData={thankyou} loop={false} />
                <div className="mt-2 ff-poppins-medium fs-14">
                  Your feedback has been shared directly with our Founder.
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {/* Backdrop */}
      {modalOpen || feedBackmodalOpen && <div className="modal-backdrop fade show"></div>}
    </>
  )
}

export default AboutPingle
 